import { ReceiptPercentIcon } from "@heroicons/react/24/solid";
import CloseIconButton from "../../../../../components/CloseIconButton";
import { Disclosure } from "@headlessui/react";
import { DoubleArrow } from "@material-ui/icons";
import { useRecoilState } from "recoil";
import { CompletedView } from "./CompletedView";
import { SubmittedInvoiceActivityHistoryView } from "../../SubmittedToAcumatica/view/SubmittedInvoiceActivityHistoryView";
import { completedData } from "../atom/atoms";
import InvoiceItemizedView from "../../InvoiceCapture/view/InvoiceItemizedView";
import InvoiceDebitAdjustmentDetails from "../../InvoiceCapture/view/InvoiceDebitAdjustmentDetails";
import { VoidedView } from "../../Voided/view/VoidedView";
import { voidedData } from "../../InvoiceCapture/atoms/atoms";

interface CompletedProp {
  cancelShow;
  rowData;
  activityHistoryData;
}

export const CompletedDetails: React.FC<CompletedProp> = ({
  cancelShow,
  rowData,
  activityHistoryData,
}) => {
  const [completedInvoiceDetails, setCompletedInvoiceDetails] =
    useRecoilState<any>(completedData);
  const [voidedInvoiceDetails, setVoidedInvoiceDetails] =
    useRecoilState<any>(voidedData);

  return (
    <>
      <div className="box-shadow p-4 border-quinary border-l-2 p-2">
        <div>
          <div className="relative -top-6 -right-4">
            <CloseIconButton
              onClick={() => {
                cancelShow();
                setCompletedInvoiceDetails(undefined);
                setVoidedInvoiceDetails(undefined);
              }}
            />
          </div>
        </div>
        <div>
          <div>
            <div className="flex justify-between items-center border-secondary border-b-2 ">
              <div>
                <div className="flex gap-2 items-center py-2">
                  <div>
                    <ReceiptPercentIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                  </div>
                  <div className="flex flex-col leading tight">
                    <h3 className="text-xs font-medium text-gray-500 ">
                      Vendor Invoice Processing
                    </h3>
                    <h1 className="mr-auto font-bold text-primary text-md uppercase pb-2">
                      Batch List - {rowData?.id}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-xs space-y-2 my-2">
              <div className="ml-auto py-2 flex rounded box-shadow justify-between ">
                <div className="space-x-4 mr-6 self-center mx-2 text-pink-500 font-bold">
                  {rowData?.vendorName} - {rowData?.vendorCode}
                </div>
              </div>
            </div>
            <div className="">
              <div className="mt-2 bg-white p-4 box-shadow rounded-md">
                <div className="text-quinary pb-4 font-bold ">
                  Vendor Information
                </div>
                <div className="grid grid-cols-3 items-center">
                  <div className="self-start">
                    <div className="expandedLabelVIP fontExpand ml-2">
                      {rowData?.vendorName}
                    </div>
                    <div>
                      <div className="expandedDataVIP fontExpand ml-2">
                        {rowData?.vendorCode}
                      </div>
                    </div>
                  </div>
                  <div className="self-start">
                    <div className="expandedLabelVIP fontExpand ml-4">
                      {rowData?.officeName}
                    </div>
                    <div className="expandedLabelVIP fontExpand ml-4">
                      {rowData?.officeStreet} {", "} {rowData?.officeCity}{" "}
                      {", "}
                      {rowData?.officeStateCode}
                    </div>
                    <div className="expandedLabelVIP fontExpand ml-4">
                      {rowData?.officeZipcode}
                    </div>
                  </div>
                  <div className="self-start">
                    <div className="expandedLabelVIP fontExpand ml-4">
                      Vendor ID: {rowData?.vendorCode}
                    </div>
                    <div className="expandedLabelVIP fontExpand ml-4">
                      Address Code: {rowData?.vendorCode}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full">
              {completedInvoiceDetails &&
                completedInvoiceDetails?.map((data) => {
                  return (
                    <>
                      <div className=" mt-2 bg-white p-4 box-shadow rounded-md">
                        <div className="flex flex-row justify-between">
                          <div className="font-bold text-quinary ">
                            Invoice Details{" "}
                            {completedInvoiceDetails
                              ? completedInvoiceDetails?.length + 1
                              : 1}{" "}
                            - Completed
                          </div>
                        </div>
                        <CompletedView rowData={data} />
                      </div>
                    </>
                  );
                })}
            </div>
            <div className="w-full">
              {voidedInvoiceDetails &&
                voidedInvoiceDetails?.map((data, index) => {
                  return (
                    <>
                      <Disclosure>
                        {({ open }) => (
                          <>
                            <div className="mt-2 bg-white rounded-lg box-shadow ">
                              <div className="flex flex-row justify-between">
                                <div className="text-quinary font-bold font-sans py-2 px-3">
                                  Invoice Details {index + 1} - Voided
                                </div>
                                <div>
                                  <Disclosure.Button className="disclosureBtn ml-2 justify-end">
                                    <DoubleArrow
                                      className={`${
                                        open
                                          ? "transform rotate-90"
                                          : " text-gray-500"
                                      }  text-gray-500 w-5 h-5 mr-4`}
                                    />
                                  </Disclosure.Button>
                                </div>
                              </div>
                              <Disclosure.Panel className="text-xxs">
                                <div className="">
                                  <VoidedView rowData={data} />
                                </div>
                              </Disclosure.Panel>
                            </div>
                          </>
                        )}
                      </Disclosure>
                    </>
                  );
                })}
            </div>
            {/* Debit Adjusment Section */}
            {completedInvoiceDetails &&
            completedInvoiceDetails[0]?.debitAdjBillRef?.length > 0 ? (
              <div className="w-full bg-white">
                {completedInvoiceDetails &&
                  completedInvoiceDetails?.map((data) => {
                    return (
                      <>
                        <Disclosure defaultOpen={true}>
                          {({ open }) => (
                            <>
                              <div className=" bg-white rounded-lg shadow-lg">
                                <div className="flex flex-row justify-between mt-2">
                                  <div className="text-pink-500 font-bold font-sans py-2 px-3">
                                    Debit Adjusment
                                  </div>
                                  <div>
                                    <Disclosure.Button className="disclosureBtn ml-2 justify-end">
                                      <div className="flex flex-row justify-end">
                                        <div className="flex flex-row mr-4">
                                          <label className="text-quinary font-bold font-sans mr-2">
                                            Bill Adjustment:
                                          </label>
                                          <div className="bg-gray-100 border-gray-100 rounded shadow-md">
                                            <label className="text-black font-bold font-sans ml-2 mr-2">
                                              $
                                              {data.billAdjustment.length > 0
                                                ? data.billAdjustment.reduce(
                                                    (bill, adj) => bill + adj,
                                                    0
                                                  )
                                                : data.billAdjustment[0]}
                                            </label>
                                          </div>
                                        </div>
                                        <DoubleArrow
                                          className={`${
                                            open ? "transform rotate-180" : ""
                                          }  text-gray-500 w-5 h-5 mr-4`}
                                        />
                                      </div>
                                    </Disclosure.Button>
                                  </div>
                                </div>
                                <Disclosure.Panel className="text-xxs">
                                  <InvoiceDebitAdjustmentDetails
                                    rowData={data?.debitAdjustmentDetails}
                                  />
                                </Disclosure.Panel>
                                <div className="flex flex-row justify-end py-2 px-3 mr-7">
                                  <div className="bg-gray-100 border-4 border-gray-100 rounded shadow-md">
                                    <label className="text-quinary font-bold font-sans ml-2 mr-2">
                                      Total Amount Paid:
                                    </label>
                                    <label className="text-black font-bold font-sans mr-2">
                                      {data.billAdjustment.length > 0
                                        ? "$" +
                                          (data.amountPaid -
                                            data.billAdjustment.reduce(
                                              (bill, adj) => bill + adj,
                                              0
                                            ))
                                        : "$"}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </Disclosure>
                      </>
                    );
                  })}
              </div>
            ) : (
              ""
            )}
            {/* Allocation Section */}
            <div className="w-full bg-white ">
              {completedInvoiceDetails &&
                completedInvoiceDetails?.map((data) => {
                  return (
                    <>
                      <Disclosure defaultOpen={true}>
                        {({ open }) => (
                          <>
                            <div className=" bg-white rounded-lg box-shadow">
                              <div className="flex flex-row justify-between mt-2">
                                <div className="text-quinary font-bold font-sans py-2 px-3">
                                  Allocation Section
                                </div>
                                <div>
                                  <Disclosure.Button className="disclosureBtn ml-2 justify-end">
                                    <DoubleArrow
                                      className={`${
                                        open
                                          ? "transform rotate-90"
                                          : " text-gray-500"
                                      }  text-gray-500 w-5 h-5 mr-4`}
                                    />
                                  </Disclosure.Button>
                                </div>
                              </div>
                              <Disclosure.Panel className="text-xxs">
                                <InvoiceItemizedView
                                  rowData={data?.itemizeDetails ?? []}
                                />
                              </Disclosure.Panel>
                            </div>
                          </>
                        )}
                      </Disclosure>
                    </>
                  );
                })}
            </div>
            <div className="w-full bg-white">
              <Disclosure>
                {({ open }) => (
                  <>
                    <div className=" bg-white rounded-lg box-shadow">
                      <div className="flex flex-row justify-between mt-2">
                        <div className="text-quinary font-bold font-sans py-2 px-3">
                          Activity History
                        </div>
                        <div>
                          <Disclosure.Button className="disclosureBtn ml-2 justify-end">
                            <DoubleArrow
                              className={`${
                                open ? "transform rotate-90" : " text-gray-500"
                              }  text-gray-500 w-5 h-5 mr-4`}
                            />
                          </Disclosure.Button>
                        </div>
                      </div>
                      <Disclosure.Panel className="text-xxs">
                        <SubmittedInvoiceActivityHistoryView
                          activityHistoryData={activityHistoryData}
                        />
                      </Disclosure.Panel>
                    </div>
                  </>
                )}
              </Disclosure>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
